import {
  withCompInfo,
  withStateRefsValues,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations/siteAssets';

const props = withCompInfo<any, any>()(['compData'], ({ compData }) => {
  return {
    ...{
      icon: {
        svgId:
          "<svg data-bbox='20 20 160 160' viewBox='0 0 200 200' height='200' width='200' xmlns='http://www.w3.org/2000/svg' data-type='shape'>\n    <g>\n        <path d='M180 100c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z'/>\n    </g>\n</svg>",
      },
      indicatorStyle: 'icon',
      currentSlide: 1,
      slidesToDisplay: 3,
    },
    ...compData,
  };
});

const css = withCompInfo<any, any>()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const { numbersSpacing = 5, iconsSpacing = 10 } = styleProperties;
    return {
      '--numbers-spacing': numbersSpacing,
      '--icons-spacing': iconsSpacing,
    };
  },
);

export const stateRefs = withStateRefsValues(['editorType']);

export default createComponentMapperModel({ props, css, stateRefs });
